export const SERVER_URL = process.env.SERVER_URL
